import { render, staticRenderFns } from "./BookingEventItem.vue?vue&type=template&id=3c2e6661&scoped=true&lang=html&"
import script from "./BookingEventItem.vue?vue&type=script&lang=js&"
export * from "./BookingEventItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2e6661",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
